class ScrollButtons {
  constructor(root) {
    this.root = root;
    this.target = this.root.querySelector("[data-scroll-buttons-target]");
    this.leftButton = this.root.querySelector("[data-scroll-buttons-left]");
    this.rightButton = this.root.querySelector("[data-scroll-buttons-right]");

    this.leftButton.addEventListener("click", this.scrollLeft.bind(this));
    this.rightButton.addEventListener("click", this.scrollRight.bind(this));
  }

  scrollLeft() {
    this.target.scrollTo({
      left: this.target.scrollLeft - this.target.clientWidth,
      behavior: "smooth",
    });
  }

  scrollRight() {
    this.target.scrollTo({
      left: this.target.scrollLeft + this.target.clientWidth,
      behavior: "smooth",
    });
  }
}

class TabSwitcher {
  constructor(root) {
    this.root = root;
    this.tabButtons = Array.from(this.root.querySelectorAll(`[role="tab"]`));
    this.tabPanels = Array.from(
      this.root.querySelectorAll(`[role="tabpanel"]`)
    );

    this.tabButtons.forEach((button) => {
      button.addEventListener("click", this.tabButtonClicked.bind(this));
    });
  }

  tabButtonClicked(event) {
    const tabButton = event.currentTarget;
    const tabPanel = document.getElementById(
      tabButton.getAttribute("aria-controls")
    );
    this.tabButtons.forEach((x) => {
      x.removeAttribute("aria-selected");
    });
    this.tabPanels.forEach((x) => {
      x.hidden = true;
    });
    tabButton.setAttribute("aria-selected", "true");
    tabPanel.hidden = false;
  }
}
/*********************************************
 * Variant Sales Label Helpers
 *********************************************/

// Parse JSON inside <script class="ProductSalesData">...</script>
function getSalesDataForProductCard(cardEl) {
  const scriptEl = cardEl.querySelector(".ProductSalesData");
  if (!scriptEl) return null;
  try {
    return JSON.parse(scriptEl.textContent.trim());
  } catch (e) {
    console.warn("Failed to parse ProductSalesData", e);
    return null;
  }
}

// Update .sales-label text for a single product card
function updateCardSalesLabel(cardEl, variantId) {
  const salesData = getSalesDataForProductCard(cardEl);
  if (!salesData || !salesData.variants) return;

  const labelEl = cardEl.querySelector(".sales-label");
  if (!labelEl) return;

  const variantInfo = salesData.variants.find((v) => String(v.id) === String(variantId));
  const text = (variantInfo && variantInfo.sales_label ? variantInfo.sales_label.trim() : "");

  if (text === "") {
    labelEl.classList.add("hidden");
    labelEl.textContent = "";
  } else {
    labelEl.textContent = text;
    labelEl.classList.remove("hidden");
  }
}

// Handle hover / click on variant swatches inside collection cards
function handleVariantInteract(e) {
  const swatch = e.target.closest(".product-block-options__item");
  if (!swatch) return;

  const variantId = swatch.getAttribute("data-variant-id");
  if (!variantId) return;

  const cardEl = swatch.closest(".product-block");
  if (!cardEl) return;

  updateCardSalesLabel(cardEl, variantId);
}

// Initialize for collection/search product grids
function initCollectionVariantLabelBehavior() {
  if (window.__collectionVariantLabelInit) return;
  window.__collectionVariantLabelInit = true;

  document.addEventListener("click", handleVariantInteract);
  document.addEventListener("mouseenter", handleVariantInteract, true);
}

/*********************************************
 * PDP Variant Sales Label Sync
 *********************************************/

function updatePdpSalesLabel(selectedVariantId) {
  const labelEl = document.querySelector(".sales-label");
  if (!labelEl) return;
  if (!window.productData || !window.productData.variants) return;

  // 1. Priority: product-level label
  const globalText = (window.productData.product_sales_label || "").trim();
  if (globalText !== "") {
    labelEl.textContent = globalText;
    labelEl.classList.remove("hidden");
    return;
  }

  // 2. Fallback: variant-level label
  const variantData = window.productData.variants.find(
    (v) => String(v.id) === String(selectedVariantId)
  );
  const variantText = variantData && variantData.sales_label
    ? variantData.sales_label.trim()
    : "";

  if (variantText === "") {
    labelEl.classList.add("hidden");
    labelEl.textContent = "";
  } else {
    labelEl.textContent = variantText;
    labelEl.classList.remove("hidden");
  }
}


function initPdpVariantLabelBehavior() {
  const variantSelect = document.querySelector('select[name="id"]');
  if (!variantSelect) return;

  updatePdpSalesLabel(variantSelect.value);

  document.addEventListener("change", function (e) {
    if (e.target.matches && e.target.matches('select[name="id"]')) {
      updatePdpSalesLabel(e.target.value);
    }
  });
}

function main() {
  for (const element of document.querySelectorAll("[data-tab-switcher]")) {
    element.tabSwitcher = new TabSwitcher(element);
  }

  for (const element of document.querySelectorAll("[data-scroll-buttons]")) {
    element.scrollButtons = new ScrollButtons(element);
  }
    // Variant label logic
  initCollectionVariantLabelBehavior();
  initPdpVariantLabelBehavior();
}

main();

